import React from 'react'

import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { getShipmentTours } from 'selectors/combined'
import { getSelectedTourId } from 'selectors/tour'
import { ShipmentTour } from 'common/models/typings/Tour'

import TourCard from './Card'
import Typography from '../../base/Typography'

import useStyles from './useStyles'
import { calculateTotalHoursOfTour } from './calculateTotalHoursOfTour'
import moment from 'moment/moment'
import get from 'lodash/get'
import last from 'lodash/last'

const AnimatedTourCard: React.FC = () => {
  const tours: ShipmentTour[] = useSelector(getShipmentTours)
  const selectedTourId: ShipmentTour['id'] | null =
    useSelector(getSelectedTourId)
  const classes = useStyles()

  const { t } = useTranslation()

  const overallProductivity = React.useMemo(() => {
    let totalStops = 0
    let totalHours = 0

    tours.forEach((tour, index) => {
      const amountOfStops = tour.collations.length
      totalStops += amountOfStops

      const { startTime, endTime } = {
        startTime: moment(get(tour.collations, '[0].estimation')).format(
          'HH:mm',
        ),
        endTime: moment(get(last(tour.collations), 'estimation')).format(
          'HH:mm',
        ),
      }

      const totalDurationInHours = calculateTotalHoursOfTour(startTime, endTime)

      totalHours += totalDurationInHours
    })

    return (totalStops / totalHours).toFixed(1)
  }, [tours])

  const filteredTours = React.useMemo(() => {
    const filtTours = tours.filter(
      (tr) => String(tr.id) === String(selectedTourId),
    )

    if (filtTours.length === 0) {
      return tours
    }

    return filtTours
  }, [tours, selectedTourId])

  return (
    <>
      {!!tours.length && (
        <div className={classes.tourLabelRow}>
          <Typography variant="textBold" className={classes.tourCountLabel}>
            {t('TOUR_COUNT', { count: tours.length })}
          </Typography>
          <Typography variant="textBold" className={classes.tourCountLabel}>
            {t('OVERALL_TOUR_PRODUCTIVITY', {
              count: overallProductivity as unknown as number,
            })}
          </Typography>
        </div>
      )}
      {filteredTours.map((tour) => (
        <TourCard
          key={tour.id}
          id={tour.id}
          color={tour.color}
          collations={tour.collations}
          hasBermudaStop={tour.hasBermudaStop}
          number={tour.number}
          totalDistance={tour.totalDistance}
          isWorking={tour.isWorking}
          driverId={tour.driverId}
          vehicleType={tour.vehicleType}
          totalDuration={tour.totalDuration}
        />
      ))}
    </>
  )
}

export default AnimatedTourCard
